import { Link } from 'react-router-dom';
import ThemeToggle from './ThemeToggle';
import styles from '../styles/Header.module.css';

function Header() {
    return (
        <header className={styles.header}>
            <nav className={styles.nav} aria-label="Main navigation">
                <Link to="/" className={styles.logo}>
                    <h1>Prashant Nagoorkar</h1>
                </Link>
                <div className={styles.navRight}>
                    <ul className={styles.navLinks}>
                        {/* Home link retained for future use but removed from nav
                        <li>
                            <Link to="/home">Home</Link>
                        </li>
                        */}
                        <li>
                            <Link to="/blog">Blog</Link>
                        </li>
                        <li>
                            <Link to="/about">About</Link>
                        </li>
                    </ul>
                    <ThemeToggle />
                </div>
            </nav>
        </header>
    );
}

export default Header;
